import { render } from "./AudioPlayer.vue?vue&type=template&id=0fd832b3&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=0fd832b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd832b3"]])

export default __exports__